import type { AddToLocalSgidToObjectMap } from "@circle-react-shared/uikit/TipTapBlockEditor/EmbedExtension/types";
import { Modal } from "@circleco/compass/components/Modal";
import type { Editor } from "@tiptap/core";

import { t } from "@/i18n-js/instance";

import { EmbedForm, getEmbedDescription, useEmbedForm } from "./EmbedForm";

interface EmbedModalComponentProps {
  addToLocalSgidToObjectMap?: AddToLocalSgidToObjectMap;
  editor: Editor;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  provider?: string;
  range: { from: number; to: number };
}

const FORM_ID = "tiptap-embed-form";

export const EmbedModalComponent = ({
  editor,
  range,
  addToLocalSgidToObjectMap,
  provider,
  open,
  onOpenChange,
}: EmbedModalComponentProps) => {
  const title = provider
    ? t("tiptap.extensions.embed.add_provider", { provider })
    : t("tiptap.extensions.embed.add");

  const { url, error, handleChange, handleSubmit, isEmpty, isLoading } =
    useEmbedForm({
      addToLocalSgidToObjectMap,
      editor,
      range,
    });

  return (
    <Modal.Root open={open} onOpenChange={onOpenChange} size="md">
      <Modal.Content>
        <Modal.Header
          title={title}
          description={getEmbedDescription(provider)}
        />
        <Modal.Body>
          <EmbedForm
            formId={FORM_ID}
            url={url}
            error={error}
            onChange={handleChange}
            onSubmit={handleSubmit}
          />
        </Modal.Body>
        <Modal.Footer
          primaryAction={{
            type: "submit",
            form: FORM_ID,
            label: t("courses.edit.lesson.embed_media"),
            loading: isLoading,
            disabled: isEmpty || isLoading,
          }}
          secondaryAction={{
            label: t("cancel"),
            onClick: () => onOpenChange(false),
          }}
        />
      </Modal.Content>
    </Modal.Root>
  );
};
